// DateRangePopup.tsx
import React from 'react';
import styled from '@emotion/styled';
import { Box, Button, Divider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup';
import dayjs from 'dayjs';

const PopupBody = styled('div')(
  ({ theme }) => `
  width: max-content;
  margin-top: 8px;
  border-radius: 8px;
  border: 1px solid ${theme.palette.mode === 'dark' ? ' #293241' : '#DAE2ED'};
  background-color: ${theme.palette.mode === 'dark' ? ' #151C26' : '#fff'};
  box-shadow: ${
    theme.palette.mode === 'dark'
      ? `0px 4px 8px rgb(0 0 0 / 0.7)`
      : `0px 4px 8px rgb(0 0 0 / 0.1)`
  };
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  z-index: 1000;
  color:black;
`
);

interface DateRangePopupProps {
  open: boolean;
  anchor: HTMLElement | null;
  tempFromDate: dayjs.Dayjs | null;
  tempToDate: dayjs.Dayjs | null;
  minDate?: any;
  maxDate?: any;
  error?: string;
  onFromChange: (value: dayjs.Dayjs | null) => void;
  onToChange: (value: dayjs.Dayjs | null) => void;
  onApply: () => void;
  onCancel: () => void;
}

const DateRangePopup = ({
  open,
  anchor,
  tempFromDate,
  tempToDate,
  minDate,
  maxDate,
  error,
  onFromChange,
  onToChange,
  onApply,
  onCancel,
}: DateRangePopupProps) => {
  return (
    <BasePopup open={open} anchor={anchor} style={{ zIndex: 1 }} placement="bottom-end">
      <PopupBody>
        <Box>
          <Box style={{ padding: '15px' }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <DesktopDatePicker
                  label="From"
                  format="DD-MM-YYYY"
                  maxDate={maxDate}
                  minDate={minDate}
                  value={tempFromDate}
                  slotProps={{ textField: { size: 'small' } }}
                  sx={{ width: '140px' }}
                  onChange={(newValue) => onFromChange(dayjs(newValue))}
                />
                <DesktopDatePicker
                  label="To"
                  format="DD-MM-YYYY"
                  maxDate={maxDate}
                  minDate={minDate}
                  value={tempToDate}
                  slotProps={{ textField: { size: 'small' } }}
                  sx={{ width: '140px' }}
                  onChange={(newValue) => onToChange(dayjs(newValue))}
                />
              </Box>
            </LocalizationProvider>
          </Box>
          {error && <p style={{ color: 'red', paddingLeft: 16 }}>{error}</p>}
          <Divider />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, padding: '15px' }}>
            <Button
              variant="outlined"
              onClick={onApply}
              sx={{
                backgroundColor: '#25258f',
                color: 'white',
                '&:hover': { backgroundColor: '#25258f' },
              }}
            >
              Apply
            </Button>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
          </Box>
        </Box>
      </PopupBody>
    </BasePopup>
  );
};

export default DateRangePopup;
